import { ref, unref, watch } from 'vue';
import RealEstateBrokerInvestmentsAPI from 'dashboard/api/realEstateBrokerInvestments';

export function useRealEstateBrokerInvestmentDetail({
  investmentId,
  notify,
  t = key => key,
} = {}) {
  const detail = ref(null);
  const loading = ref(false);
  const error = ref('');

  const load = async () => {
    const id = unref(investmentId);
    if (!id) return;

    loading.value = true;
    error.value = '';
    try {
      const response = await RealEstateBrokerInvestmentsAPI.show(id);
      detail.value = response.data?.data || null;
    } catch {
      detail.value = null;
      error.value = t('REAL_ESTATE_BROKER_INVESTMENT.DETAIL.ERROR');
      if (notify) notify(error.value, null, { variant: 'error' });
    } finally {
      loading.value = false;
    }
  };

  watch(() => unref(investmentId), load, { immediate: true });

  return { detail, loading, error, load };
}
